import React from 'react';
type DaisyProps = {
  left: number;
  top: number;
  size: number;
  petals: number;
  petalW: number;
  petalH: number;
  petalColor: string;
  centerSize: number;
  bob: string;
};
function Daisy({
  left,
  top,
  size,
  petals,
  petalW,
  petalH,
  petalColor,
  centerSize,
  bob
}: DaisyProps) {
  return <div className="ct-daisy" style={{
    left,
    top,
    width: size,
    height: size
  }} data-id="element-221" data-mp="uzuuwfdmr9yo">
      <div className="absolute inset-0" style={{
      animation: bob
    }} data-id="element-222" data-mp="1iqh449zdf0a9">
        {Array.from({
        length: petals
      }, (_, i) => <div key={i} className="absolute top-[2px] rounded-full" style={{
        left: (size - petalW) / 2,
        width: petalW,
        height: petalH,
        background: petalColor,
        transformOrigin: `${petalW / 2}px ${petalH - 1}px`,
        transform: `rotate(${360 / petals * i}deg)`
      }} data-id="element-223" data-mp="1nplc4xak6rz0" />)}
        <div className="absolute rounded-full bg-[#FCEFA8] shadow-[inset_0_0_0_3px_#F3DC6B]" style={{
        left: (size - centerSize) / 2,
        top: (size - centerSize) / 2,
        width: centerSize,
        height: centerSize
      }} data-id="element-224" data-mp="26gl6yf4qiw07" />
      </div>
    </div>;
}
export function Flowers() {
  return <div className="relative h-[90px] w-[200px]" aria-hidden="true" data-id="element-225" data-mp="chvvae9w7mtp">
      <Daisy left={10} top={6} size={70} petals={8} petalW={16} petalH={34} petalColor="#FFFFFF" centerSize={22} bob="ct-bob 7s ease-in-out infinite" data-id="element-226" data-mp="7pu83xb6sbow" />
      <div className="absolute left-[72px] top-8 h-1 w-[66px] rotate-[18deg] rounded bg-[#2F7069]" data-id="element-227" data-mp="mdfec03cyr11" />
      <Daisy left={132} top={20} size={56} petals={6} petalW={14} petalH={28} petalColor="#F2A99C" centerSize={18} bob="ct-bob 8s ease-in-out 1s infinite" data-id="element-228" data-mp="hfx8wjojutxs" />
    </div>;
}
export function Cup() {
  return <div className="ct-cup relative h-[120px] w-[150px]" aria-hidden="true" data-id="element-229" data-mp="rc8u5z64au4d">
      <div className="absolute left-0 top-0 h-[120px] w-[120px] rounded-full bg-[#FFFFFF] shadow-[0_6px_0_rgba(30,75,72,0.12)]" data-id="element-230" data-mp="2x7tic5vrxpr9" />
      <div className="absolute left-[104px] top-[49px] h-[22px] w-10 rounded-[11px] bg-[#E5634D]" data-id="element-231" data-mp="2t82jrg00a5c6" />
      <div className="absolute left-[18px] top-[18px] h-[84px] w-[84px] rounded-full bg-[#F9E4DE] shadow-[inset_0_0_0_4px_#F2A99C]" data-id="element-232" data-mp="1146pzgb2472z" />
      <div className="absolute left-7 top-7 h-16 w-16 rounded-full bg-[#B56A2E]" data-id="element-233" data-mp="1630337mflw2m" />
      <div className="absolute left-10 top-[38px] h-2.5 w-[18px] rounded-full bg-[rgba(255,240,220,0.5)]" data-id="element-234" data-mp="1b22wfut1udur" />
      <div className="ct-puff" style={{
      left: 46,
      top: 44,
      width: 26,
      height: 26
    }} data-id="element-235" data-mp="1f4hewdst3bli" />
      <div className="ct-puff" style={{
      left: 60,
      top: 50,
      width: 22,
      height: 22,
      animationDelay: '1.1s'
    }} data-id="element-236" data-mp="1k2rfx517p6f1" />
      <div className="ct-puff" style={{
      left: 36,
      top: 52,
      width: 20,
      height: 20,
      animationDelay: '2.2s'
    }} data-id="element-237" data-mp="1ot7tcp518s1e" />
    </div>;
}